import React from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    MenuItem,
    TextField,
    Tooltip,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

export default function MaterialDialog({
    open,
    editingMaterialIndex,
    currentMaterial,
    materialErrors,
    articles,
    onClose,
    onSave,
    onFieldChange,
    onArticleChange,
    onOpenNewArticle,
}) {
    return (
        <Dialog open={open} onClose={onClose} PaperProps={{ sx: { borderRadius: 3 } }}>
            <DialogTitle>{editingMaterialIndex !== null ? "Material bearbeiten" : "Material hinzufügen"}</DialogTitle>
            <DialogContent dividers>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                    <Box sx={{ display: "flex", gap: 1 }}>
                        <TextField
                            select
                            label="Artikel"
                            value={currentMaterial.articleId}
                            onChange={(event) => onArticleChange(event.target.value)}
                            fullWidth
                            error={Boolean(materialErrors.articleId)}
                            helperText={materialErrors.articleId || ""}
                        >
                            <MenuItem value=""></MenuItem>
                            {currentMaterial.articleId &&
                                !articles.some((article) => article?.id === currentMaterial.articleId) && (
                                    <MenuItem value={currentMaterial.articleId}>
                                        {currentMaterial.articleName || "Unbekannter Artikel"}
                                    </MenuItem>
                                )}
                            {articles.map((article) => (
                                <MenuItem key={article.id} value={article.id}>
                                    {article.name || article.articleNumber || "Unbenannter Artikel"}
                                </MenuItem>
                            ))}
                        </TextField>
                        <Tooltip title="Neuen Artikel anlegen">
                            <Button variant="outlined" onClick={onOpenNewArticle} aria-label="Neuen Artikel anlegen">
                                <AddIcon />
                            </Button>
                        </Tooltip>
                    </Box>
                    <TextField
                        label="Menge"
                        type="number"
                        value={currentMaterial.amount}
                        onChange={(event) => onFieldChange("amount", event.target.value)}
                        fullWidth
                        inputMode="decimal"
                        inputProps={{ step: "0.01", min: "0" }}
                        error={Boolean(materialErrors.amount)}
                        helperText={materialErrors.amount || ""}
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
                <Button onClick={onClose} color="inherit">
                    Abbrechen
                </Button>
                <Button
                    onClick={onSave}
                    variant="contained"
                    sx={{ bgcolor: "orange", "&:hover": { bgcolor: "#cc7a00" }, borderRadius: 2, color: "#000" }}
                >
                    Speichern
                </Button>
            </DialogActions>
        </Dialog>
    );
}
